import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import SubgroupMenu from "components/Business/SubgroupMenu/SubgroupMenu";

import * as projectReducer from "containers/Project/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as nextModelsReducer from "containers/Next/Models/ModelsReducer";

class SubgroupMenuContainer extends React.Component {
  state = {
    show: false
  };

  handleClick(e, override) {
    const { onClick } = this.props;
    if (onClick) {
      return onClick();
    }
    return this.setState({
      show: override !== undefined ? override : !this.state.show
    });
  }

  render() {
    return <SubgroupMenu {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = ownProps.id;
  return {
    updateDrilldownValue: (runId, drilldownValue) => {
      dispatch(projectReducer.updateDrilldownValue(id, runId, drilldownValue));
    }
  };
};

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.id;
  const optimized = projectReducer.getOptimized(state, id);
  const runId = optimized && optimized.innerId;
  return {
    project: projectReducer.getProject(state, id),
    optimized: optimized,
    transactionLabel: setupReducer.getTransactionLabel(state, runId),
    outcomeLabel: setupReducer.getOutcomeLabel(state, runId),
    notPursuedTransactionLabel: setupReducer.getNotPursuedTransactionLabel(state, runId),
    trueAction: setupReducer.getTrueAction(state, runId),
    falseAction: setupReducer.getFalseAction(state, runId),
    optimizer: projectReducer.getOptimizer(state, id),
    modelGroups: projectReducer.getModelGroups(state, id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(SubgroupMenuContainer);
